/* Goodwilly – Gratisversand-Anzeige mit Socken-Vorschlägen
 * Daten kommen aus snippets/gw-free-shipping.liquid (JSON im <gw-free-shipping>-Element).
 * Darstellung im Shadow DOM, damit das Neu-Rendern des Warenkorbs (morph) die Anzeige nicht zerstört.
 */
(function () {
  if (window.customElements.get('gw-free-shipping')) return;

  var TRUCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>';
  var CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  var CSS = [
    ':host{display:block;--a:var(--gw-accent,#C85E2E);color:inherit;font:inherit}',
    ':host([context="drawer"]){padding-inline:var(--cart-drawer-padding,16px);padding-block-start:4px}',
    '*{box-sizing:border-box}',
    '.gw{background:rgba(200,94,46,.07);border:1px solid rgba(200,94,46,.18);border-radius:16px;padding:14px 14px 12px;margin:0 0 18px}',
    '.row{display:flex;align-items:center;gap:10px}',
    '.ico{flex:0 0 28px;width:28px;height:28px;border-radius:50%;background:var(--a);color:#fff;display:grid;place-items:center}',
    '.msg{margin:0;font-size:14px;line-height:1.35}',
    '.msg strong,.tip strong{color:var(--a);font-weight:700;white-space:nowrap}',
    '.bar{position:relative;height:8px;border-radius:99px;background:rgba(200,94,46,.16);margin:11px 0 0;overflow:hidden}',
    '.bar span{position:absolute;top:0;bottom:0;left:0;border-radius:inherit;background:var(--a);transition:width .6s cubic-bezier(.2,.8,.2,1)}',
    '.tip{margin:10px 0 0;font-size:13px;line-height:1.45;opacity:.85}',
    '.sug{margin-top:13px;padding-top:12px;border-top:1px dashed rgba(200,94,46,.3)}',
    '.sug-head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:10px}',
    '.label{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--a)}',
    '.sizes{display:flex;gap:6px}',
    '.sizes button{font:inherit;font-size:11px;line-height:1;padding:6px 10px;border-radius:99px;border:1px solid rgba(0,0,0,.14);background:#fff;color:inherit;cursor:pointer;transition:background .2s,color .2s,border-color .2s}',
    '.sizes button[aria-pressed="true"]{background:var(--a);border-color:var(--a);color:#fff}',
    '.cards{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}',
    ':host([context="page"]) .cards{grid-template-columns:repeat(auto-fill,minmax(140px,1fr))}',
    '.card{background:#fff;border-radius:12px;padding:6px;display:flex;flex-direction:column;gap:5px;min-width:0}',
    '.card a{color:inherit;text-decoration:none;display:flex;flex-direction:column;gap:5px;min-width:0}',
    '.card img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:8px;display:block;background:#f4efea}',
    '.t{font-size:12px;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.p{font-size:12px;display:flex;flex-wrap:wrap;gap:0 5px;align-items:baseline}',
    '.p b{color:var(--a);font-weight:700}',
    '.p s{opacity:.5;font-size:11px}',
    '.add{font:inherit;font-size:12px;font-weight:600;line-height:1.2;border:0;border-radius:99px;background:var(--a);color:#fff;padding:7px 8px;cursor:pointer;width:100%;margin-top:auto;transition:filter .2s,transform .1s}',
    '.add:hover{filter:brightness(.92)}',
    '.add:active{transform:scale(.97)}',
    '.add[disabled]{opacity:.75;cursor:default}',
    '.set{display:flex;align-items:center;gap:10px;margin-top:10px;background:#fff;border-radius:12px;padding:6px 8px 6px 6px}',
    '.set img{width:48px;height:48px;border-radius:8px;object-fit:cover;flex:0 0 48px;background:#f4efea}',
    '.set p{margin:0;font-size:12px;line-height:1.35;flex:1;min-width:0}',
    '.set p strong{color:var(--a)}',
    '.set .add{width:auto;flex:0 0 auto;padding:7px 12px;margin-top:0}',
    '.more{display:inline-flex;align-items:center;gap:4px;margin-top:8px;font-size:13px;font-weight:600;color:var(--a);text-decoration:none}',
    '.more:hover{text-decoration:underline}',
    '@media (max-width:749px){.gw{padding:12px 12px 10px;margin-bottom:12px}.msg{font-size:13.5px}.tip{font-size:12.5px;margin-top:8px}}',
    '@media (prefers-reduced-motion:reduce){.bar span{transition:none}}'
  ].join('');

  function dec(s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(s == null ? '' : s);
    return ta.value;
  }
  function decAll(o) { var r = {}; Object.keys(o || {}).forEach(function (k) { r[k] = dec(o[k]); }); return r; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function fill(tpl, map) {
    return esc(tpl).replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function mkFmt(sample) {
    var m = String(sample || '').match(/1(\D?)000(?:(\D)(\d+))?/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var th = m[1] || '', dec = m[2] || '', dd = m[3] ? m[3].length : 0;
    var pre = sample.slice(0, m.index), post = sample.slice(m.index + m[0].length);
    return function (cents) {
      var parts = (Math.max(0, cents) / 100).toFixed(dd).split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return pre + intPart + (dd ? dec + parts[1] : '') + post;
    };
  }

  class GwFreeShipping extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) this.attachShadow({ mode: 'open' });
      this._last = null;
      this.render();
      var self = this;
      if (!this._mo) {
        this._mo = new MutationObserver(function () { self.render(); });
        this._mo.observe(this, { childList: true, subtree: true, characterData: true });
      }
    }
    disconnectedCallback() {
      if (this._mo) { this._mo.disconnect(); this._mo = null; }
    }
    render(force) {
      var node = this.querySelector('script[type="application/json"]');
      var raw = node ? node.textContent : '';
      if (!force && raw === this._last) return;
      this._last = raw;
      var d = null;
      try { d = JSON.parse(raw); } catch (e) { d = null; }
      if (!d) { this.shadowRoot.innerHTML = ''; return; }
      this._d = d;

      var t = decAll(d.t);
      var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
      var fmt = mkFmt(d.sample);
      var thr = Math.round(d.threshold * rate);
      var ship = Math.round(d.ship * rate);
      var disc = Math.round(d.pairDisc * rate);
      var T = d.total, c = d.pairs || 0, min = d.pairMin || 4;
      var inCart = d.inCart || [];

      var sizes = [];
      (d.products || []).forEach(function (p) { p.v.forEach(function (v) { if (sizes.indexOf(v.s) < 0) sizes.push(v.s); }); });
      var size = this._size || d.size || sizes[0];
      if (sizes.indexOf(size) < 0) size = sizes[0];
      this._size = size;

      var cands = [];
      (d.products || []).forEach(function (p) {
        if (inCart.indexOf(p.id) >= 0) return;
        var v = p.v.filter(function (x) { return x.s === size && x.a; })[0];
        if (v) cands.push({ p: p, v: v });
      });
      var P = cands.length ? cands[0].v.p : (d.pairPrice || 0);
      var pairSetPrice = P - disc;

      function totalWith(n) {
        var k = c + n;
        return T + n * P - (k >= min ? k * disc : 0) + (c >= min ? c * disc : 0);
      }

      var remaining = thr - T;
      var reached = remaining <= 0;
      var n = 0, nt = T;
      if (!reached && P > 0) {
        for (n = 1; n <= 20; n++) { nt = totalWith(n); if (nt >= thr) break; }
      }
      var pct = Math.max(4, Math.min(100, Math.round((T / thr) * 100)));

      var html = '<style>' + CSS + '</style><div class="gw' + (reached ? ' is-done' : '') + '">';
      html += '<div class="row"><span class="ico">' + (reached ? CHECK : TRUCK) + '</span><p class="msg">';
      html += reached ? esc(t.reached) : fill(t.away, { amount: '<strong>' + esc(fmt(remaining)) + '</strong>' });
      html += '</p></div>';
      html += '<div class="bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';

      var showSug = false;
      if (!reached && n > 0 && n <= 20) {
        var tip = fill(n === 1 ? t.tip_one : t.tip_other, {
          count: String(n),
          total: '<strong>' + esc(fmt(nt)) + '</strong>',
          shipping: esc(fmt(ship))
        });
        var setPrice = (d.sets && d.sets.length && d.sets[0].p) || 4499;
      if (c > 0 && c < min && c + n >= min && t.set_hint) tip += ' ' + fill(t.set_hint, { price: '<strong>' + esc(fmt(setPrice)) + '</strong>' });
        html += '<p class="tip">' + tip + '</p>';
        showSug = true;
      } else if (reached && c > 0 && c < min) {
        var k = min - c;
        html += '<p class="tip">' + fill(k === 1 ? t.to_set_one : t.to_set_other, {
          count: String(k),
          price: '<strong>' + esc(fmt(pairSetPrice)) + '</strong>'
        }) + '</p>';
        showSug = true;
      }

      if (showSug && d.browseUrl) {
        html += '<a class="more" href="' + esc(d.browseUrl) + '">' + esc(t.browse || '') + ' <span aria-hidden="true">→</span></a>';
      }
      html += '</div>';
      this.shadowRoot.innerHTML = html;

      var self = this;
      this.shadowRoot.querySelectorAll('[data-size]').forEach(function (b) {
        b.addEventListener('click', function () { self._size = b.getAttribute('data-size'); self.render(true); });
      });
      this.shadowRoot.querySelectorAll('[data-add]').forEach(function (b) {
        b.addEventListener('click', function () { self.add(b); });
      });
    }

    async add(btn) {
      var d = this._d || {}, t = decAll(d.t);
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = t.adding || '…';
      var line = { id: Number(btn.getAttribute('data-add')), quantity: 1 };
      if (btn.getAttribute('data-po') === '1' && d.prop && d.prop.name) {
        line.properties = {};
        line.properties[d.prop.name] = d.prop.value;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function (el) {
        if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
      });

      var events = null;
      try { events = await import('@shopify/events'); } catch (e) { events = null; }
      var deferred = null;
      if (events && events.CartLinesUpdateEvent) {
        deferred = events.CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(line.id), quantity: 1 }],
          promise: deferred.promise
        }));
      }

      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [line], sections: sectionIds.join(',') })
        });
        var data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'error');
        var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        btn.textContent = t.added || '✓';
        if (deferred) {
          deferred.resolve({
            cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'gw-free-shipping',
              sourceId: 'gw-free-shipping',
              itemCount: 1,
              productId: data.items && data.items[0] && data.items[0].product_id,
              sections: data.sections,
              didError: false
            }
          });
        } else {
          window.location.reload();
        }
      } catch (err) {
        console.error('[gw-free-shipping]', err);
        if (deferred) deferred.reject(err);
        btn.textContent = t.error || 'Error';
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2500);
      }
    }
  }

  window.customElements.define('gw-free-shipping', GwFreeShipping);
})();
